import { jsx as _jsx } from "react/jsx-runtime";
import classnames from 'classnames';
import useConfig from '../../hooks/useConfig';
import ColumnProductProduct from './columnProduct';
import RowProduct from './rowProduct';
var cls = 'product-list';
var classnamesMap = {
  1: 'one-columns',
  2: 'two-columns',
  3: 'three-columns',
  row: 'scroll-row'
};

var ProductList = function ProductList(_ref) {
  var className = _ref.className,
      id = _ref.id,
      pid = _ref.pid,
      config = _ref.config,
      render = _ref.render,
      onClick = _ref.onClick;

  var _useConfig = useConfig(),
      createNamespace = _useConfig.createNamespace,
      prefixCls = _useConfig.prefixCls;

  var products = config.products,
      productRow = config.productRow,
      meta = config.meta;
  var classes = classnames(createNamespace === null || createNamespace === void 0 ? void 0 : createNamespace(cls, prefixCls), classnamesMap[productRow || 2], className);
  var Product = productRow === 1 ? RowProduct : ColumnProductProduct;
  return _jsx("div", Object.assign({
    "data-pid": pid,
    className: classes,
    "data-componentid": id
  }, {
    children: products === null || products === void 0 ? void 0 : products.map(function (product, index) {
      var _a, _b;

      return _jsx(Product, {
        meta: meta === null || meta === void 0 ? void 0 : meta[(_a = product.product) === null || _a === void 0 ? void 0 : _a.id],
        index: index,
        id: id,
        pid: pid,
        column: productRow,
        product: product,
        render: render,
        onClick: onClick,
        className: classnamesMap[productRow]
      }, (_b = product.product) === null || _b === void 0 ? void 0 : _b.id);
    })
  }));
};

ProductList.displayName = 'ProductList';
ProductList.defaultProps = {
  config: {
    parseType: 'id',
    productRow: 2,
    quantity: 0
  }
};
export default ProductList;